import { render, staticRenderFns } from "./CommunityCaseSessions.vue?vue&type=template&id=b98cda50&scoped=true"
import script from "./CommunityCaseSessions.vue?vue&type=script&lang=js"
export * from "./CommunityCaseSessions.vue?vue&type=script&lang=js"
import style0 from "./CommunityCaseSessions.vue?vue&type=style&index=0&id=b98cda50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98cda50",
  null
  
)

export default component.exports